import axios from 'axios';

// local
// const URL = 'http://localhost:1999';

// LIVE
const URL = 'https://live.asktek.net/ask_websites_manager_api';

const ImageURL = URL;
axios.defaults.logo = `${ImageURL}/Images/logo`;
axios.defaults.products = `${ImageURL}/Images`;

export default axios.create({
  // For Development
  baseURL: `${URL}/api`,
  headers: {
    authtoken: sessionStorage.getItem('authToken'),
    companycode: sessionStorage.getItem('companycode'),
  },
});
